<template>
    <div>
        <Head title="Правила бонусу балансу"/>
        <h1 class="mb-8 text-3xl font-bold">Правила бонусу балансу</h1>
        <div class="flex items-center justify-between mb-6">
            <Link class="btn-indigo" :href="$route('bonus-rules.create')">
                <span>Створити правило</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Назва</th>
                    <th class="pb-4 pt-6 px-6">Мінімальна загальна сума замовлень (грн)</th>
                    <th class="pb-4 pt-6 px-6">Бонус (%)</th>
                    <th class="pb-4 pt-6 px-6">Активне</th>
                </tr>
                <tr v-for="rule in rules" :key="rule.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="$route('bonus-rules.edit', rule.id)">
                            {{ rule.name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="$route('bonus-rules.edit', rule.id)" tabindex="-1">
                            {{ rule.min_amount == 0 ? 'Будь-яка' : rule.min_amount + ' грн' }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="$route('bonus-rules.edit', rule.id)" tabindex="-1">
                            {{ rule.bonus_percent }}%
                        </Link>
                    </td>
                    <td class="border-t px-6 py-4">
                        <span v-if="rule.is_active"
                              class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                            Так
                        </span>
                        <span v-else
                              class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-500">
                            Ні
                        </span>
                    </td>
                </tr>
                <tr v-if="rules.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">Немає жодного правила</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout.vue'

export default {
    components: { Head, Link },
    layout: Layout,
    props: {
        rules: Array,
    },
}
</script>
